//LIBRARIES
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { RadioButtonGroup, TextField, SelectField } from 'redux-form-material-ui';
import { RadioButton } from 'material-ui/RadioButton';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import MenuItem from 'material-ui/MenuItem';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

//COMPONENTS
import AddressAutocomplete from 'components/shared/addressAutocomplete';
import validate from './validate';

//HELPERS
import { colors } from 'helpers/ColorHelper';
import { getTranslatedString } from 'helpers/i18n';

//CONSTANTS
import { CANADIAN_PROVINCES, USA_STATES } from 'constants/address.constants';

const renderError = ({ meta: { touched, error } }) =>
  touched && error ? (
    <p style={{ color: colors.RED, fontSize: '11px', textAlign: 'center' }}>{error}</p>
  ) : (
    false
  );

class PropertyAddress extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentCountry: getTranslatedString('country.CA'),
    };
  }

  componentDidMount() {
    this.setState({ currentCountry: this.props.country });
  }

  /**
   * Render province/state dropdown items base on country
   * @function renderDropdownList
   */
  renderDropdownList = () => {
    const { currentCountry } = this.state;
    let dropdownList = CANADIAN_PROVINCES.map((province) => {
      return <MenuItem value={province} primaryText={province} />;
    });

    if (isEqual(currentCountry, 'United States')) {
      dropdownList = USA_STATES.map((state) => {
        return <MenuItem value={state} primaryText={state} />;
      });
    }

    return dropdownList;
  };

  /**
   * update country state when autocomplete is selected
   * @function getAddressFromAutoComplete
   * @param { address } string - passed down from autocomplete
   */
  getAddressFromAutoComplete = (address) => {
    if (!isEmpty(address)) {
      this.setState({ currentCountry: address.country });
    }
  };

  addToAddressFields = (street, city, province, country, post_code) => {
    this.props.change('street', street);
    this.props.change('city', city);
    this.props.change('province', province);
    this.props.change('country', country);
    this.props.change('postal_code', post_code);
  };

  render() {
    const { handleSubmit, streetAddress } = this.props;
    const { currentCountry } = this.state;

    return (
      <div>
        <h3 style={{ textAlign: 'center', marginBottom: '5px' }}>Property Address</h3>
        <p style={{ textAlign: 'center', marginBottom: '15px' }}>
          Add your property address below to help your prospects find your property. You&#39;ll be
          able to add the unit number(s) in a later step.
        </p>

        <form onSubmit={handleSubmit.bind(this)}>
          <div className="row" style={{ marginBottom: '70px' }}>
            <div className="row">
              <div className="col-xs-12" style={{ textAlign: 'center', zIndex: '1000' }}>
                <AddressAutocomplete
                  addToRedux={this.addToAddressFields}
                  getAddressFromAutoComplete={this.getAddressFromAutoComplete}
                  floatingLabelText="Address"
                  name="street"
                  style={{
                    fontSize: '14px',
                    width: '100%',
                  }}
                  streetAddress={streetAddress}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="city"
                  type="text"
                  component={TextField}
                  floatingLabelText="City"
                  style={{
                    fontSize: '14px',
                    width: '100%',
                  }}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                {isEqual(currentCountry, 'Canada') || isEqual(currentCountry, 'United States') ? (
                  <Field
                    name="province"
                    component={SelectField}
                    floatingLabelText={getTranslatedString('addressForm.division')}
                    style={{
                      textAlign: 'left',
                      width: '100%',
                    }}
                  >
                    {this.renderDropdownList()}
                  </Field>
                ) : (
                  <Field
                    name="province"
                    type="text"
                    component={TextField}
                    floatingLabelText={getTranslatedString('addressForm.division')}
                    style={{
                      width: '100%',
                    }}
                    errorStyle={{ fontSize: '14px' }}
                  />
                )}
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="postal_code"
                  type="text"
                  component={TextField}
                  floatingLabelText={getTranslatedString('addressForm.area')}
                  style={{
                    fontSize: '14px',
                    width: '100%',
                  }}
                />
              </div>
              <div className="col-sm-6" style={{ textAlign: 'center' }}>
                <Field
                  name="country"
                  type="text"
                  component={TextField}
                  floatingLabelText="Country"
                  style={{
                    fontSize: '14px',
                    width: '100%',
                  }}
                />
              </div>
            </div>
            {this.props.province === 'Ontario' && (
              <div>
                <h5
                  style={{
                    textAlign: 'center',
                    marginBottom: '15px',
                    marginTop: '25px',
                  }}
                >
                  When you increase the rent, do you use an N1 or N2 form?
                </h5>
                <Field
                  name="n1_or_n2"
                  component={RadioButtonGroup}
                  style={{ width: '187px', margin: 'auto' }}
                >
                  <RadioButton
                    value="n1"
                    label="N1"
                    style={{ width: '102px', display: 'inline-flex' }}
                  />
                  <RadioButton
                    value="n2"
                    label="N2"
                    style={{
                      width: '70px',
                      display: 'inline-flex',
                      float: 'right',
                    }}
                  />
                </Field>
                <Field name="n1_or_n2" component={renderError} />
              </div>
            )}
          </div>
        </form>
      </div>
    );
  }
}

const selector = formValueSelector('add_property');

PropertyAddress = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate,
})(PropertyAddress);

PropertyAddress = connect((state) => ({
  streetAddress: selector(state, 'street'),
  province: selector(state, 'province'),
  country: selector(state, 'country'),
}))(PropertyAddress);

export default PropertyAddress;
